import React from 'react';
import { Modal } from 'semantic-ui-react';
import { useQuery } from '@apollo/react-hooks';
import Loading from '../../../Loading';
import _ from 'lodash';
import EditMembership from '../EditMembership';
import QUERY_CURRENT_USER from '../../../../queries/user';

const MembershipDetails = ({ id, onClose }) => {
	const { data, loading } = useQuery(QUERY_CURRENT_USER);

	let Content = <div>There was a problem</div>;

	if(loading) {
		Content = <Loading />;
	}

	const { accountType, adminLevel } = _.get(data, 'user', { accountType: 0, adminLevel: 0 });

	if(accountType >= 10) {
		Content = <EditMembership {...{ accountType, adminLevel, id, onClose }} />;
	}

	return (
		<Modal
			open={!!id}
			onClose={onClose}
			header={<Modal.Header>Membership Details</Modal.Header>}
			content={<Modal.Content>{Content}</Modal.Content>}
			closeIcon
			closeOnDimmerClick={false}
		/>
	);
};

export default MembershipDetails;